const en = {
  // ── Navigation ──────────────────────────────────────────
  dashboard:'Dashboard',
  sales:'Sales',
  purchases:'Purchases',
  inventory:'Inventory',
  accounting:'Accounting',
  finance:'Finance',
  management:'Management',
  reports:'Reports',
  invoices:'Invoices',
  customers:'Customers',
  suppliers:'Suppliers',
  products:'Products',
  partners:'Partners',
  expenses:'Expenses',
  revenues:'Revenues',
  cashbox:'Cashbox',
  bank:'Bank',
  budget:'Budget',
  assets:'Fixed Assets',
  users:'Users',
  branches:'Branches',
  settings:'Settings',
  audit:'Audit',
  journals:'Journal Entries',
  accounts:'Chart of Accounts',
  trialBalance:'Trial Balance',
  incomeStatement:'Income Statement',
  balanceSheet:'Balance Sheet',
  customerBalanceList:'Customers Balance',
  debitBalance:'Debit',
  creditBalance:'Credit',
  newSale:'New Sale',
  salesList:'Sales List',
  purchasesList:'Purchases List',
  productsList:'Products List',
  inventoryReport:'Inventory Report',
  cashflow:'Cash Flow',
  ledger:'General Ledger',
  fiscalYears:'Fiscal Years',

  // ── Common Actions ───────────────────────────────────────
  save:'Save',
  cancel:'Cancel',
  edit:'Edit',
  delete:'Delete',
  add:'Add',
  search:'Search',
  filter:'Filter',
  print:'Print',
  export:'Export',
  close:'Close',
  confirm:'Confirm',
  approve:'Approve',
  reject:'Reject',
  back:'Back',
  view:'View',
  create:'Create',
  update:'Update',
  remove:'Remove',
  loading:'Loading...',
  noData:'No data found',
  total:'Total',
  yes:'Yes',
  no:'No',
  required:'Required',
  optional:'Optional',
  success:'Operation successful',
  error:'Error',
  warning:'Warning',
  info:'Info',
  addSuccess:'Added successfully',
  updateSuccess:'Updated successfully',
  deleteSuccess:'Deleted successfully',

  // ── Status ───────────────────────────────────────────────
  active:'Active',
  inactive:'Inactive',
  draft:'Draft',
  approved:'Approved',
  pending:'Pending',
  cancelled:'Cancelled',
  paid:'Paid',
  unpaid:'Unpaid',
  partial:'Partial',
  overdue:'Overdue',
  confirmed:'Confirmed',

  // ── Common Fields ────────────────────────────────────────
  date:'Date',
  name:'Name',
  type:'Type',
  status:'Status',
  amount:'Amount',
  currency:'Currency',
  description:'Description',
  notes:'Notes',
  code:'Code',
  actions:'Actions',
  phone:'Phone',
  email:'Email',
  address:'Address',
  number:'Number',
  reference:'Reference',
  quantity:'Qty',
  unit:'Unit',
  price:'Price',
  discount:'Discount',
  tax:'Tax',
  subtotal:'Subtotal',
  remaining:'Remaining',
  debit:'Debit',
  credit:'Credit',
  balance:'Balance',
  branch:'Branch',
  company:'Company',
  createdAt:'Created At',
  updatedAt:'Updated At',
  createdBy:'Created By',

  // ── Sales ────────────────────────────────────────────────
  saleNumber:'Sale No.',
  customer:'Customer',
  customerName:'Customer Name',
  customerPhone:'Customer Phone',
  saleType:'Sale Type',
  cash:'Cash',
  credit:'Credit',
  addPayment:'Add Payment',
  payRemaining:'Pay Remaining',
  paymentHistory:'Payment History',
  paymentMethod:'Payment Method',
  paymentAmount:'Payment Amount',
  payFull:'Pay Full',
  payHalf:'Pay Half',
  invoiceItems:'Invoice Items',
  scanBarcode:'Scan Barcode',
  selectCustomer:'Select Customer',
  cart:'Cart',
  clearCart:'Clear Cart',
  registerSale:'Register Sale',
  noStock:'Out of Stock',
  insufficientStock:'Insufficient Stock',

  // ── Purchases ────────────────────────────────────────────
  purchaseNumber:'Purchase No.',
  supplier:'Supplier',
  supplierName:'Supplier Name',
  searchSupplier:'Search supplier...',
  searchProduct:'Search product...',
  newPurchase:'New Purchase',
  purchaseItems:'Purchase Items',
  prepayment:'Prepayment',

  // ── Products ─────────────────────────────────────────────
  productName:'Product Name',
  productCode:'Product Code',
  category:'Category',
  buyPrice:'Buy Price',
  sellPrice:'Sell Price',
  setLotSellPrice:'Set Sell Price for This Batch',
  lotSellPriceNote:'Each purchase batch keeps its own sell price, separate from other batches of the same product.',
  currentStock:'Current Stock',
  minStock:'Min Stock',
  barcode:'Barcode',
  brand:'Brand',
  newProduct:'New Product',
  stockValue:'Stock Value',
  lowStockAlert:'Low Stock Alert',

  // ── Customers ────────────────────────────────────────────
  customerProfile:'Customer Profile',
  customerDebt:'Customer Debt',
  payDebt:'Pay Debt',
  totalPurchases:'Total Purchases',
  totalSales:'Total Sales',
  accountBalance:'Net Balance',
  customerOwesUs:'Customer owes us',
  weOweCustomer:'We owe the customer',
  salesRemaining:'Sales Remaining (Receivable)',
  purchasesRemaining:'Purchases Remaining (Payable)',
  totalPayments:'Total Payments',
  lastTransaction:'Last Transaction',
  accountStatement:'Account Statement',
  purchasedProducts:'Purchased Products',
  fifoPayment:'FIFO Payment',

  // ── Suppliers ────────────────────────────────────────────
  supplierProfile:'Supplier Profile',
  supplierDebt:'Supplier Debt',
  paySupplier:'Pay Supplier',
  purchaseHistory:'Purchase History',

  // ── Accounting ───────────────────────────────────────────
  chartOfAccounts:'Chart of Accounts',
  journalEntries:'Journal Entries',
  accountCode:'Account Code',
  accountName:'Account Name',
  accountType:'Account Type',
  asset:'Asset',
  liability:'Liability',
  equity:'Equity',
  liabilities:'Liabilities',
  cashOnHand:'Cash on Hand',
  autoAccountsNote:'The chart of accounts is created and maintained automatically',
  autoJournalNote:'All entries are posted automatically from sales, purchases, expenses, revenue and cashbox transactions',
  revenue:'Revenue',
  expense:'Expense',
  group:'Group',
  general:'General',
  subsidiary:'Subsidiary',
  normalBalance:'Normal Balance',
  parentAccount:'Parent Account',
  journalNumber:'Journal No.',
  entry:'Entry',
  lines:'Lines',
  balanced:'Balanced',
  unbalanced:'Unbalanced',
  addLine:'Add Line',
  saleUnitsConfig:'Other Sale Units (with conversion factor)',
  saleUnitsConfigNote:'Example: Carton = 10 Pieces — selling 1 Carton reduces 10 Pieces from stock.',
  noUnitsAdded:'No additional unit added',
  unitName:'Unit name (e.g. Carton)',
  conversionFactor:'Factor',
  selectUnit:'Select Unit',

  // ── Finance ──────────────────────────────────────────────
  transaction:'Transaction',
  receipt:'Receipt',
  payment:'Payment',
  transfer:'Transfer',
  cashBalance:'Cash Balance',
  bankBalance:'Bank Balance',
  totalIncome:'Total Income',
  totalOutcome:'Total Outcome',

  // ── Reports ──────────────────────────────────────────────
  salesReport:'Sales Report',
  purchasesReport:'Purchases Report',
  customersReport:'Customers Report',
  suppliersReport:'Suppliers Report',
  inventoryRep:'Inventory Report',
  expensesReport:'Expenses Report',
  cashboxReport:'Cashbox Report',
  incomeReport:'Income Statement',
  topCustomers:'Top Customers',
  dailyChart:'Daily Chart',
  period:'Period',
  today:'Today',
  thisWeek:'This Week',
  thisMonth:'This Month',
  thisQuarter:'This Quarter',
  thisYear:'This Year',
  custom:'Custom',
  startDate:'From Date',
  endDate:'To Date',
  refresh:'Refresh',
  grossProfit:'Gross Profit',
  netProfit:'Net Profit',
  totalExpenses:'Total Expenses',
  totalRevenue:'Total Revenue',
  operatingProfit:'Operating Profit',

  // ── Partners ─────────────────────────────────────────────
  partner:'Partner',
  partnerCode:'Partner Code',
  partnerName:'Partner Name',
  partnerType:'Partner Type',
  individual:'Individual',
  joinDate:'Join Date',
  sharePercent:'Share %',
  capital:'Capital',
  initialCapital:'Initial Capital',
  currentCapital:'Current Capital',
  addCapital:'Add Capital',
  reduceCapital:'Reduce Capital',
  transferCapital:'Transfer Capital',
  withdraw:'Withdrawal',
  invest:'Investment',
  profitShare:'Profit Share',
  totalPartners:'Total Partners',
  totalCapital:'Total Capital',
  undistributedProfit:'Undistributed Profit',
  monthWithdrawals:'Month Withdrawals',
  monthDeposits:'Month Deposits',
  capitalAccount:'Capital Account',
  currentAccount:'Current Account',
  profitAccount:'Profit Account',
  withdrawalAccount:'Withdrawal Account',
  partnerReport:'Partner Report',
  capitalReport:'Capital Report',
  transactionHistory:'Transaction History',
  distributeProfit:'Distribute Profit',
  shareAmount:'Share Amount',

  // ── Dashboard ────────────────────────────────────────────
  todaySales:"Today's Sales",
  monthSales:'Month Sales',
  lowStock:'Low Stock',
  outOfStock:'Out of Stock',
  totalCustomers:'Total Customers',
  todayInvoices:"Today's Invoices",
  receivable:'Receivables',
  payable:'Payables',
  recentSales:'Recent Sales',
  stockWarning:'Stock Warning',
  monthlySales:'Monthly Sales',

  // ── Exchange Rate ────────────────────────────────────────
  exchangeRate:'Exchange Rate',
  liveRate:'Live Rate',
  lastUpdated:'Last Updated',
  rateUnavailable:'Rate unavailable',
  manualRate:'Manual Rate',
  updateRate:'Update Rate',
  afn:'AFN',
  usd:'USD',

  // ── Validation Messages ──────────────────────────────────
  fieldRequired:'This field is required',
  invalidEmail:'Invalid email',
  minLength:'Minimum {n} characters',
  maxLength:'Maximum {n} characters',
  mustBeNumber:'Must be a number',
  mustBePositive:'Must be greater than zero',
  deleteReason:'Delete reason is required',
  balanceRequired:'Debit must equal Credit',
  shareExceeds:'Total shares exceed 100%',

  // ── Placeholders ─────────────────────────────────────────
  phName:'Enter name...',
  phPhone:'e.g. 0799123456',
  phEmail:'example@email.com',
  phAddress:'Full address...',
  phAmount:'e.g. 50000',
  phDescription:'Enter description...',
  phSearch:'Search...',
  phCode:'Auto generated',
  phNotes:'Additional notes...',
  phBuyPrice:'Buy price...',
  phSellPrice:'Sell price...',
  phStock:'Stock quantity...',
  phBarcode:'Barcode (optional)',
  phDiscount:'0',
  phReference:'Reference number...',

  // ── Extended v2 ──────────────────────────────────────────
  saving:'Saving...',
  registering:'Registering...',
  loading2:'Loading...',
  noParentAccount:'No parent account',
  parentAccount2:'Parent Account',
  optional2:'(Optional)',
  allItems:'All',
  last6Months:'Last 6 months',
  selectBranch:'Please select a branch from the top menu',
  branchRequired:'No branch selected',
  settled2:'✓ Settled',
  overdue2:'Overdue',
  noDataChart:'No data to display',
  totalBankBalance:'Total Bank Balance',
  bankTransfer:'Transfer Between Accounts',
  registerTransfer:'Register Transfer',
  newBankAccount:'New Account',
  cashboxBalance:'Cashbox Balance',
  cashboxAccount:'Cashbox',
  createCashbox:'Create Cashbox',
  editCashbox:'Edit Cashbox',
  cashboxName:'Cashbox Name',
  phCashboxName:'e.g. Main Cash, Bank Account...',
  initialDeposit:'Initial Deposit',
  noCashboxYet:'No cashbox created yet',
  openingBalance:'Opening Capital',
  capital:'Capital',
  source:'Source',
  automatic:'Automatic',
  manual:'Manual',
  addCapital:'Add Capital',
  addCapitalNote:'This form is only for recording opening or additional capital. Sales, purchases, expenses and revenue are posted automatically.',
  autoCashboxNote:'Sales, purchases, expenses and revenue are posted automatically',
  totalReceipt:'Total Receipts',
  totalPayment:'Total Payments',
  transactionType:'Transaction Type *',
  reportCenter:'Reports Center',
  timePeriod:'Time Period',
  incomeChart:'+ Revenues',
  expensesChart:'- Expenses',
  dailyPurchasesChart:'Daily Purchases Chart',
  byCategory:'Expenses by Category',
  stockByCategory:'Stock Value by Category',
  incomeStatement2:'Income Statement',
  compareChart:'Comparison Chart',
  topCustomers2:'Top Customers',
  selectAccount:'Select account...',
  journalLines:'Journal Lines',
  accountingSettings:'Accounting Settings',
  todayRate:"Today's Exchange Rate",
  initialStock:'Initial Stock',
  autoCode:'Product Code (Auto)',
  minStockAlert:'Min Stock Alert',
  stockValuePage:'Stock Value (Current Page)',
  buyPriceLabel:'Buy Price *',
  sellPriceLabel:'Sell Price *',
  financialSummary:'Financial Summary',
  documentInfo:'Document Info',
  quickSelect:'Quick Select:',
  invoiceFooter:'This invoice was generated by the accounting system',
  newFiscalYear:'New Fiscal Year',
  locked:'Locked',
  closedStatus:'Closed',
  selectPartner:'Select partner...',
  lastTransactions:'Last Transactions',
  noTransactionYet:'No transactions yet',
  noInvoiceYet:'No invoices yet',
  noProductYet:'No products purchased',
  noPurchaseYet:'No purchases yet',
  noPaymentYet:'No payments yet',
  overdueInvoices:'Overdue invoices (oldest first):',
  overdueCount:'Overdue invoices',
  fifoMsg:'Payment starts from oldest (FIFO)',
  overduePurchases:'Overdue purchases (oldest first):',
  overduePurchasesCount:'Overdue purchases',
  exceedsDebt:'⚠ Exceeds total debt',
  incomeSectionTitle:'Revenues',
  expensesSectionTitle:'Expenses',
  profitMargin:'Profit Margin',
  reportPeriod:'Report Period',
  noIncomeYet:'No revenues yet',
  noExpenseYet:'No expenses yet',
  expensesBreakdown:'Expenses Breakdown',
  mainInfo:'Main Info',
  priceInfo:'Price & Stock Info',
  stockMovement:'Stock Movement',
  noStockMovement:'No stock movement yet',
  deleteConfirm:'Confirm Delete',

  // ── Additional for Pages ─────────────────────────────────
  chartOfAccounts:'Chart of Accounts',
  accounts:'Accounts',
  accountLevel:'Account Level',
  resource:'Resource',
  id:'ID',
  ipAddress:'IP Address',
  loginLogout:'Login/Logout',
  companyInfo:'Company Information',
  registrationNo:'Registration No.',
  taxId:'Tax ID',
  website:'Website',
  baseCurrency:'Base Currency',
  secondCurrency:'Second Currency',
  invoicePrefix:'Invoice Prefix',
  journalPrefix:'Journal Prefix',
  autoJournal:'Auto Journal Entry',
  requireApproval:'Require Approval',
  dateFormat:'Date Format',
  jalali:'Jalali',
  gregorian:'Gregorian',
  bankManagement:'Bank Account Management',
  bankName:'Bank Name',
  accountNumber:'Account Number',
  ibanNumber:'IBAN',
  fromAccount:'From Account',
  toAccount:'To Account',
  totalAssets:'Total Assets',
  totalBookValue:'Total Book Value',
  bookValue:'Book Value',
  depreciationMethod:'Depreciation Method',
  salvageValue:'Salvage Value',
  usefulLife:'Useful Life (years)',
  accumulatedDepreciation:'Accumulated Depreciation',
  underMaintenance:'Under Maintenance',
  disposed:'Disposed',
  auditSubtitle:'All user operations are automatically logged',
  logout:'Logout',

  // Journals
  journalEntries:'Journal Entries',
  newJournal:'New Journal',
  noJournals:'No journals found',
  lineDescription:'Line Description',
  journalNumber:'Journal No.',
  cancelled:'Cancelled',
  isBalanced:'Balanced',
  unbalanced:'Unbalanced',

  // NewSale
  prepayment:'Prepayment',
  paymentExceeds:'Payment cannot exceed total amount',
  productNotFound:'Product with this barcode not found',
  registered:'registered',
  manageBranches:'Manage Branches',
  phSearchCustomer:'Customer name, phone...',
  phSearchProduct:'Product name, brand or category...',
  items:'Items',
  emptyCart:'Cart is empty',
  amount:'Amount',
  percent:'Percent',

  // ProductDetail
  salesHistory:'Sales History',
  purchaseHistory:'Purchase History',
  profitPerUnit:'Profit per unit',
  inStock:'In Stock',

  // Products
  phSearchProducts:'Search: name, code or barcode...',
  toggleStatus:'Toggle Status',
  unitPcs:'Pcs',
  unitEach:'Each',
  unitPack:'Pack',
  unitPacket:'Packet',
  unitBox:'Box',
  unitBranch:'Branch',
  unitCarton:'Carton',
  unitSheet:'Sheet',
  unitKg:'Kg',
  unitGram:'Gram',
  unitLiter:'Liter',
  unitMeter:'Meter',
  unitSet:'Set',
  phMinStock:'e.g. 5',

  // PurchaseDetail
  purchaseDocument:'Purchase Document',
  supplierInfo:'Supplier Information',
  documentNumber:'Document No.',
  createdAt:'Created At',
  purchaseType:'Purchase Type',
  registerPayment:'Register Payment',
  paymentHistory:'Payment History',
  noSupplier:'No Supplier',
  paymentProgress:'Payment Progress',
  unsettledDocument:'Unsettled Document',
  paySupplier:'Pay Supplier',
  enterAmount:'Enter payment amount...',
  exceedsRemaining:'Exceeds remaining balance',
  payHalf:'Pay Half',
  optionalNotes:'Optional notes...',

  // Purchases
  purchasesList:'Purchases List',
  thisMonthPurchases:'This Month Purchases',
  supplierDebt:'Supplier Debt',
  purchaseCount:'Purchase Count',
  purchasesAmount:'Purchases Amount',
  salesCount:'Sales Count',
  month:'Month',
  autoFiscalYearNote:'Everything is calculated automatically from document dates',
  phSearchPurchase:'Number or supplier...',
  phSearchSupplier:'Search by name or phone...',
  selectAtLeastOneProduct:'Select at least one product',
  enterPrepayment:'Enter initial payment amount...',
  purchase:'Purchase',
  transactionsList:'Payments & Balances List',
  details:'Details',

  // Revenues
  newRevenue:'New Revenue',
  noRevenues:'No revenues found',
  revenueTitle:'Revenue Title',
  phRevenueTitle:'e.g. Monthly sales, rent income...',
  receiptMethod:'Receipt Method',
  referenceNumber:'Reference / Cheque No.',

  // Reports
  reportCenter:'Reports Center',
  salesReport:'Sales Report',
  purchasesReport:'Purchases Report',
  customersReport:'Customers Report',
  suppliersReport:'Suppliers Report',
  invoiceCount:'Invoice Count',
  dailyPurchasesChart:'Daily Purchases Chart',
  customersList:'Customers List',
  debtorCustomers:'Debtor Customers',
  suppliersList:'Suppliers List',
  suppliersWithDebt:'With Debt',
  totalSuppliers:'Total Suppliers',
  productsList:'Products List',
  expensesList:'Expenses List',
  cashboxTransactions:'Cashbox Transactions',
  printDate:'Print Date',
  other:'Other',

  // SaleDetail
  customerInfo:'Customer Information',
  invoiceInfo:'Invoice Information',
  invoiceNumber:'Invoice Number',
  saleDate:'Sale Date',
  saleType:'Sale Type',
  unitPrice:'Unit Price',
  tax:'Tax',
  paymentProgress:'Payment Progress',
  unsettledInvoice:'Unsettled Invoice',
  paymentNotesPlaceholder:'Payment description...',

  // Sales
  salesList:'Sales List',
  currentCredit:'Current Credit',
  printInvoice:'Print Invoice',
  sale:'Sale',

  // SupplierProfile
  paymentRegistered:'Payment registered',
  paymentForPurchase:'Payment for purchase',
  overduePurchases:'Overdue purchases',
  payFullDebt:'Pay full debt',

  // Suppliers
  totalSuppliers:'Total Suppliers',
  activeSuppliers:'Active Suppliers',
  profile:'Profile',
  phTaxId:'Tax ID...',

  // Branches & Users
  branchManagement:'Branch Management',
  branches:'Branches',
  newBranch:'New Branch',
  branchName:'Branch Name',
  branchCode:'Branch Code',
  mainBranch:'Main Branch',
  totalBranches:'Total Branches',
  activeBranches:'Active Branches',
  inactiveBranches:'Inactive Branches',
  noBranches:'No branches found',
  editBranch:'Edit Branch',
  phBranchName:'e.g. Kabul Branch',
  phBranchCode:'e.g. KBL',
  managerName:'Branch Manager',
  phManagerName:'Manager Name',
  isMainBranch:'Main Branch',
  deleteBranch:'Delete Branch',
  deleteBranchConfirm:'Are you sure? Branch',
  deactivate:'Deactivate',
  activate:'Activate',
  userManagement:'User Management',
  users:'Users',
  addUser:'Add User',
  editUser:'Edit User',
  fullName:'Full Name',
  password:'Password',
  changePassword:'Change Password',
  newPassword:'New Password',
  passwordChanged:'Password changed successfully',
  minLengthPassword:'Minimum 6 characters',
  lastLogin:'Last Login',
  branchAccess:'Branch Access',
  phSearchUser:'Name or email...',
  deletedByAdmin:'Deleted by admin',


  // Partners
investmentDeposit:'Investment / Deposit',
capitalIncrease:'Capital Increase',
capitalDecrease:'Capital Decrease',
partnerWithdrawal:'Partner Withdrawal',
transferToPartner:'Transfer to Partner',
profitDistributed:'Profit distributed',
monthNetProfit:'Month Net Profit',
totalShare:'Total Share',
remainingShare:'Remaining Share',
noPartners:'No partners registered',
noPartnersFound:'No partners found',
phSearchPartner:'Name, code, phone...',
phSharePercent:'e.g. 33.33',
phInitialCapital:'e.g. 100000',
partnerAddress:'Partner address',
saveTransaction:'Save Transaction',
profitAmount:'Profit Amount',
phProfitAmount:'Enter profit amount to distribute...',
phProfitDesc:'Profit distribution description...',
distributionPreview:'Distribution Preview',
manualDistribution:'Manual Distribution Between Partners',
suggestByPercent:'Suggest by Percentage',
fullyAllocated:'Fully allocated',
remainingToAllocate:'Remaining to allocate',
shareChangeHistory:'Share Change History',
shareChanges:'Share Changes',
partnerReport:'Partner Report',
filterTransactionType:'Filter Transaction Type',
allTransactions:'All Transactions',
change:'Change',
partnerName:'Partner Name',
noChanges:'No changes recorded',
transferReceived:'Transfer Received',
transferPaid:'Transfer Paid',
profit:'Profit',
phTransactionDesc:'Write transaction description...',
toPartner:'To Partner',
partnersCapitalReport:'Partners Capital Report',

};



export default en;